import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DatePipe } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { DateServiceService } from 'app/shared/common/helper/dateservice';
import { HardCodedValues } from 'app/shared/common/hard-coded-values';
import { ToastrService } from 'ngx-toastr';
import { startWith, map } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { fuseAnimations } from '@fuse/animations';
import { SocketService } from 'app/shared/common/helper/socket.service';

@Component({
  selector: 'app-project-metrics',
  templateUrl: './project-metrics.component.html',
  styleUrls: ['./project-metrics.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})

export class ProjectMetricsComponent implements OnInit {

  projectListDetails = [];
  projectsList: any[] = [];
  projectInformation: any[] = [];
  today: any;
  currentDate: any;
  currentStatus = [];
  selectbydate = new Date();
  assignedResourcesRecords: number;
  dataRefresher: any;
  graphMetrics: any;
  supportBillableCount: any[];
  totalResources: any;
  billableCount: any[];
  addOnType: any;
  projects: any[] = [];
  projectDetails: any[] = [];
  projectMems = [];
  myControl = new FormControl();
  filteredOptions: Observable<any[]>;
  selectedProject: any = { name: '', id: '' };
  projectStatus: any[] = [
    { value: 'Time and Material Billable', viewValue: 'Time and Material Billable' },
    { value: 'Time and Material Non-Billable', viewValue: 'Time and Material Non-Billable' },
    { value: 'Fixed Billable', viewValue: 'Fixed Billable' },
    { value: 'Fixed Non-Billable', viewValue: 'Fixed Non-Billable' },
    { value: 'Unassigned', viewValue: 'Unassigned' }
  ];
  textLabel = '';
  projectMetrics: boolean;

  projectMembersIds = [];
  selectedDate = new Date();
  worklogDetail = [];
  public barChartOptions: any = {
    scaleShowVerticalLines: false,
    animation: {
      onComplete: function () {
        var chartInstance = this.chart,
          ctx = chartInstance.ctx;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'bottom';
        this.data.datasets.forEach(function (dataset, i) {
          var meta = chartInstance.controller.getDatasetMeta(i);
          meta.data.forEach(function (bar, index) {
            var data = dataset.data[index];
            ctx.fillText(data, bar._model.x, bar._model.y - 5);
          });
        });
      }
    },
    responsive: true,
    options: {
      scales: {
        yAxes: [{
          ticks: {
            reverse: false,
            stepSize: 20
          },
        }]
      }
    }
  };
  public barChartType: string = 'bar';
  public barChartLegend: boolean = false;
  public barChartColors = [
    '#64B5F6',
    '#76D7C4',
    '#B39DDB',
    '#FF8A7E',
    '#FF87AB',
    '#F18EE1',
    '#72AEFF',
    '#3AC5DE',
    '#46C7A8',
    '#68C17A',
    '#99B65F',
    '#D1A656',
  ];
  public barChartLabels = [];
  public barChartData = [];
  selectedProjectId: any;
  selectedProjectType: any;
  totalProjectHours: number;
  workDetail = [];
  totalWorkHours = '0';
  teamStatus: boolean;
  workLog: boolean;
  projectId: any;
  projectDashboard: boolean;
  selectedtabindex = 0;
  projectName: any;
  dedicatedProjectDetails = [];
  showSpinner = true;
  timesheet = false;
  userId = '';
  profileId = '';
  empRole = '';
  projectData = [];
  projectListValues = [];
  tenantId: any;
  resourceDetails: any = {
    id: this.getRandomNumber(9),
    resourceDetailDate: new Date()
  }
  projectStatusData: any[];
  BillingTypeTotalHrs = 0;

  constructor(
    private spinner: NgxSpinnerService,
    private parseService: ParseService,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private queryInterface: QueryInterface,
    private storageConfiguration: StorageConfiguration,
    private router: Router,
    private dateService: DateServiceService,
    private hardCodedValues: HardCodedValues,
    private toastr: ToastrService,
    private _socket: SocketService
  ) {
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    this.profileId = this.parseService.instance.User.current().get('profile').id;
    this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);

  }

  ngOnInit() {
    (async () => {
      await this.getAvailableProjectBillingType();
      this.projectMetrics = true;
      this.teamStatus = false;
      this.workLog = false;
      this.projectDashboard = false;
      this.getUserTimesheet();
      this.refreshData();
    })();
  }

  constructResource = (array, key) => {
    return array.reduce((result, currentValue) => {
      (result[currentValue[key]] = result[currentValue[key]] || []).push(
        currentValue
      );
      return result;
    }, {});
  };

  async getProjectMemberDetails(projectId) {
    // let queryInstance = this.parseService.instance.Object.extend('ProjectMembers');
    // let query = new this.parseService.instance.Query(queryInstance);
    // query.equalTo('status', 'Assigned');
    // query.equalTo('project', { __type: 'Pointer', className: 'Project', objectId: projectId })
    // query.equalTo('tenantId', this.tenantId);
    // let result = await query.find();
    // let data = JSON.stringify(result);
    // let projectMember = JSON.parse(data);
    // console.log(projectMember);
    // * get project members form the projectMems array instead of fetch by calling service each time;
    let projectMember = this.projectMems.filter(member => member.attributes.project.id === projectId);
    const details = [];
    const resourceGroup = await this.constructResource(projectMember, 'role');
    for (const [key, value] of Object.entries(resourceGroup)) {
      let hoursMonth = 0;
      resourceGroup[key].forEach(element => {
        let data = element.hours ? element.hours : element.months;
        return hoursMonth = hoursMonth + data;
      });

      const detailsObject = {
        "id": this.getRandomNumber(9),
        "role": key,
        "count": resourceGroup[key].length,
        "hours": hoursMonth
      }
      details.push(detailsObject);
    }
    return this.resourceDetails['details'] = details;
  }

  getRandomNumber(val) {
    const timestamp = +new Date();
    length = val;
    var ts = timestamp.toString();
    var parts = ts.split('').reverse();
    var id = '';

    for (var i = 0; i < length; ++i) {
      var index = this.generateRandomNumber(0, parts.length - 1);
      id += parts[index];
    }
    return id;
  }

  generateRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  /*
  ** ==========================================================
  ** Get User Timesheet Details
  ** ==========================================================
  */
  async getUserTimesheet() {
    let userTimesheet = [];
    this.currentStatus = [];

    var datePipe = new DatePipe('en-US');
    this.currentDate = datePipe.transform(this.selectbydate, 'MM/dd/yyyy');
    this.today = datePipe.transform(new Date(), 'MM/dd/yyyy');

    let selctedDate = new Date(this.selectbydate);
    let dateDifferent = this.dateService.startEndDateByDate(new Date(selctedDate));
    let userClass = this.parseService.instance.Object.extend('UserTimeSheet');
    let query = new this.parseService.instance.Query(userClass);
    query.greaterThan('createdAt', dateDifferent[0]);
    query.lessThan('createdAt', dateDifferent[1]);
    query.include('profileId');
    query.include('profileId.location');
    // query.equalTo('tenantId', this.tenantId);
    query.limit(10000000);
    let results = await query.find();
    userTimesheet = JSON.parse(JSON.stringify(results));
    // console.log('userTimesheet', userTimesheet);
    userTimesheet.forEach(element => {
      if (element.profileId != undefined) {
        this.currentStatus.push(element);
      }
    });
    // console.log('currentStatus', this.currentStatus);
    this.getProjects();
  }
  async getAvailableProjectBillingType(): Promise<void> {
    // return
    this.projectStatusData = [];
    this.projectData = [];
    this.projectListValues = [];
    const Project = this.parseService.instance.Object.extend('Project');
    const query = new this.parseService.instance.Query(Project);
    query.limit(1000);
    query.equalTo('tenantId', this.tenantId);
    // query.select('schedulerStatus');
    query.containedIn('projectInfo.currentStatus', ['New', 'In Progress']);
    const data = await query.find();

    // .then((data) => {
    this.projectListValues = data;
    const projectSchedulerStatus = [];
    // const projectSchedulerStatus = ['Dedicated Billable', 'Dedicated Non-Billable', 'Fixed Billable', 'Fixed Non-Billable'];
    data.forEach(element => {
      let schedulerStatus = element.get('schedulerStatus');
      if (element.get('defaultProject')) {
        schedulerStatus = 'Unassigned';
      }
      projectSchedulerStatus.indexOf(schedulerStatus) === -1 ? projectSchedulerStatus.push(schedulerStatus) :
        console.log('This item already exists');
    });
    projectSchedulerStatus.forEach(element => {
      if (element) {
        const obj = {
          value: element,
          viewValue: element
        };
        this.projectStatusData.push(obj);
      }
    });
    this.projectStatus = this.projectStatusData;
    /**
     * * Moved the unassigned project tab to the end in the tab set
     */
    const UnassignedIndex = this.projectStatus.findIndex((element) => element.value === 'Unassigned');
    const UnassignedData = this.projectStatus.splice(UnassignedIndex, 1);
    this.projectStatus.push(...UnassignedData);
    console.log('projectStatus', this.projectStatus);
    // });
  }
  async getProjects() {
    this.projectData = [];
    this.projectListValues = [];
    let profileInstance = this.parseService.instance.Object.extend('Project');
    let query = new this.parseService.instance.Query(profileInstance);
    query.limit(1000);
    query.include('client');
    query.equalTo('tenantId', this.tenantId);
    query.containedIn('projectInfo.currentStatus', ['New', 'In Progress']);
    if (this.textLabel == 'Unassigned') {
      query.equalTo('defaultProject', true);
      query.equalTo('schedulerStatus', this.textLabel ? 'Fixed Non-Billable' : this.projectStatus[0].value);
    } else if (this.textLabel === '') {
      query.equalTo('defaultProject', false);
      query.equalTo('schedulerStatus', this.projectStatusData[0].value);
    }
    else {
      query.equalTo('defaultProject', false);
      query.equalTo('schedulerStatus', this.textLabel ? this.textLabel : this.projectStatusData[0].value);
    }
    if (this.selectedProject.id != undefined && this.selectedProject.id != '' && this.selectedProject != 'all') {
      query.equalTo('objectId', this.selectedProject.id);
    }
    this.projectListValues = await query.find();
    this.projectData = [];
    let i = 0;
    for (const element of this.projectListValues) {
      i = i + 1;
      this.projectData.push(element.id);
    }
    this.getProjectMembers();
    // console.log('projectList', this.projectDetails);
  }

  /*
    ** ==========================================================
    ** Get Project Members
    ** ==========================================================
    */
  getProjectMembers() {
    if (this.showSpinner == true) {
      this.spinner.show();
    }
    let queryInstance = this.parseService.instance.Object.extend('ProjectMembers');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('status', 'Assigned')
    query.include('user');
    query.include('user.profile');
    query.include('project');
    query.containedIn('project', this.projectData);
    query.limit(500000);
    query.equalTo('tenantId', this.tenantId);
    query.find().then(async result => {
      this.projectMems = result;
      await this.projectLists(this.projectListValues);
    });
  }

  async projectLists(projectListValues): Promise<void> {
    this.BillingTypeTotalHrs = 0;
    if (this.showSpinner == true) {
      this.spinner.show();
    }

    this.getProjectDropdown(projectListValues);

    this.projectsList = [];
    this.projectInformation = [];
    let currentProject = [];
    this.projectListDetails = [];

    let projectMembers = [];
    let projectMembersAssigned = [];
    this.billableCount = [];
    this.supportBillableCount = [];
    for (let element of projectListValues) {
      let resourceMember = await this.getProjectMemberDetails(element.id);
      let totalHrs = 0;
      currentProject = this.getProjectMembersStatus(element);
      currentProject.forEach(res => {
        totalHrs += res.workHoursInSeconds;
      })
      this.addOnType = element.get('projectInfo').addOnType;
      projectMembers = this.projectMems.filter(s => s.get('project').id == element.id);
      projectMembersAssigned = projectMembers.filter(a => a.get('status') == 'Assigned');
      let unique = this.uniqBy(projectMembersAssigned, JSON.stringify);
      this.totalResources = unique.length;
      if (this.addOnType != 'Support') {
        this.billableCount = unique.filter(a => (a.get('resourcesType')) == ((element.get('projectInfo').projectType) == 'Dedicated' ? 'Dedicated-Billable' : 'Fixed-Billable'));
      }
      else if (this.addOnType == 'Support') {
        this.supportBillableCount = unique.filter(a => (a.get('resourcesType')) == 'Support-Billable');
      }
      let typeOfProject = element.get('projectInfo').projectType ? element.get('projectInfo').projectType : element.get('projectInfo').addOnType;
      this.projectInformation.push({
        projectId: element.id,
        projectType: element.get('projectType') == 'Project' ? element.get('projectType') : element.get('projectInfo').addOnType,
        typeOfProject: typeOfProject,
        projectStartDate: element.get('projectInfo').projectStartDate ? element.get('projectInfo').projectStartDate : '',
        projectActualCompletionDate: element.get('projectInfo').actualCompletionDate ? element.get('projectInfo').actualCompletionDate : '',
        projectExtendedCompletionDate: element.get('projectInfo').extendedCompletionDate ? element.get('projectInfo').extendedCompletionDate : '',
        totalResources: this.totalResources ? this.totalResources : '',
        billableCount: this.billableCount ? this.billableCount : '',
        supportBillableCount: this.supportBillableCount ? this.supportBillableCount : '',
        resourceDetails: resourceMember,
        name: element.get('projectInfo').projectName,
        projectInfo: element.get('projectInfo'),
        projectMembers: this.getProjectMembersStatus(element),
        projectDetails: this.getProjectDetails(element),
        totalHrs: this.secondsToHms(Math.ceil(totalHrs / 1000)),
        totalHrsInSeconds: totalHrs,
        defaultProject: element.attributes.defaultProject
      });
      this.BillingTypeTotalHrs += totalHrs;
    }
    this.projectListDetails = (this.projectInformation).sort((a, b) => b.totalHrsInSeconds - a.totalHrsInSeconds);
    // console.log('projectList', this.projectDetails);
    // console.log('projectListDetails', this.projectListDetails);

    this.spinner.hide();
  }

  uniqBy(a, key) {
    var index = [];
    return a.filter(function (item) {
      var k = key(item);
      return index.indexOf(k) >= 0 ? false : index.push(k);
    });
  }

  /*
    ** ==========================================================
    ** Get Projects Dropdown
    ** ==========================================================
    */
  getProjectDropdown(results): void {
    this.projectList(results);
  }

  projectList(results): void {
    this.projects = [];
    this.projectDetails = [];
    results.forEach(element => {
      this.projects.push({ id: element.id, name: element.get('projectInfo').projectName + ' - ' + element.get('projectType') });
      this.projectDetails.push({ id: element.id, name: element.get('projectInfo').projectName, projectInfo: element.get('projectInfo') });
    });
    this.projects = this.projects.sort((a, b) => a.name.trim().localeCompare(b.name.trim()));
    this.getFilteredValue();
  }

  getFilteredValue() {
    if (this.projects.length > 0) {
      this.filteredOptions = this.myControl.valueChanges.pipe(
        startWith(''),
        map(skillSets => this._filter(skillSets))
      );
    }
  }
  private _filter(value: string): any[] {
    let projects = JSON.stringify(this.projects);
    let projectList = JSON.parse(projects);
    const filterValue = value.toLowerCase();
    return projectList.filter(option => option.name
      .toString()
      .toLowerCase()
      .includes(filterValue)
    );
  }

  getProjectDetails(project) {
    let proMembers = [];
    let proMembersAssigned = [];
    let dedicatedProjectDetails = [];

    proMembers = this.projectMems.filter(s => s.get('project').id == project.id);
    proMembersAssigned = proMembers.filter(a => a.get('status') == 'Assigned');

    let resourceDetails = project.get('resourceDetails').details;
    if (resourceDetails.length > 0 && project.get('projectInfo').projectType == 'Dedicated') {
      for (const data of resourceDetails) {
        let selectedRole = proMembersAssigned.filter(x => x.get('role') == data.role);
        let billableCount = selectedRole.filter(y => y.get('resourcesType') == 'Dedicated-Billable');
        let nonBillableCount = selectedRole.filter(y => y.get('resourcesType') != 'Dedicated-Billable');
        dedicatedProjectDetails.push({
          role: data.role,
          billableCount: billableCount.length,
          nonBillableCount: nonBillableCount.length
        });
      }
    }
    return dedicatedProjectDetails;
  }

  /*
  ** ==========================================================
  ** Get Project Members Status(Work, Idle, Log out, Not logged In)
  ** ==========================================================
  */
  getProjectMembersStatus(project) {
    if (this.showSpinner == true) {
      this.spinner.show();
    }
    let proMembers = [];
    let proMembersAssigned = [];
    let profileDetails = [];
    let currentStatus = [];
    let workTime;
    let profile = [];
    let sortArray = [];
    proMembers = this.projectMems.filter(s => s.get('project').id == project.id);
    proMembersAssigned = proMembers.filter(a => a.get('status') == 'Assigned');
    for (const res of proMembersAssigned) {
      if (Object.keys(res.get('user').get('profile').get('profileImageInfo')).length > 0) {
        var profilePic = res.get('user').get('profile').get('profileImageInfo').url ? res.get('user').get('profile').get('profileImageInfo').url : '';
      }
      else {
        var profilePic: any = '../../../../../assets/images/avatars';
      }
      let firstName = res.get('user').get('profile').get('firstName');
      let lastName = res.get('user').get('profile').get('lastName');
      let name = firstName + ' ' + lastName;
      let profileId = res.get('user').get('profile').id;
      currentStatus = this.currentStatus.filter(x => x.profileId.objectId == res.get('user').get('profile').id);
      currentStatus.forEach(result => {
        let workHours = 0;
        let totalAttendance = result.totalAttendance;
        let workDatas = totalAttendance.project.filter(a => a.id == project.id);
        workTime = result.workTime.slice(-1).pop();
        workDatas.forEach(workData => {
          workHours += workData.actualHours;
        });
        if (workTime != undefined && workTime.project.id == project.id) {
          status = result.currentStatus;
        }
        else {
          status = 'working in another project';
        }
        let data = profileDetails.filter(x => x.profileId == res.get('user').get('profile').id);
        if (data.length == 0) {
          profileDetails.push({
            profileId: profileId,
            projectId: project.id,
            name: name,
            profilePic: profilePic,
            currentStatus: result.isClosed == true ? 'Log Out' : status.charAt(0).toUpperCase() + status.slice(1),
            workHours: this.secondsToHms(Math.ceil(workHours / 1000)),
            workHoursInSeconds: workHours
          });
        }
      });
      if (currentStatus.length === 0) {
        profileDetails.push({
          profileId: profileId,
          projectId: project.id,
          name: name,
          profilePic: profilePic,
          currentStatus: 'Idle',
          workHours: '00:00',
          workHoursInSeconds: 0
        });
      }
    }

    sortArray = profileDetails.sort((a, b) => b.workHoursInSeconds - a.workHoursInSeconds);
    var sortOrder = ['Work', 'Idle', 'Working in another project', 'Log Out'];
    profile = sortArray.sort(function (a, b) {
      return sortOrder.indexOf(a.currentStatus) - sortOrder.indexOf(b.currentStatus);
    });
    return profile;

  }

  getMetricsBasedOnProjectStatus(event) {
    this.selectedProject = { name: '', id: '' };
    this.myControl.setValue('');
    if (event.tab != undefined) {
      this.selectedtabindex = event.index;

      this.textLabel = event.tab.textLabel != undefined ? event.tab.textLabel : '';
      this.getProjects();
    }
    else {
      this.selectedtabindex = this.selectedtabindex;
    }
  }

  /*
  ** ==========================================================
  ** Getting the latest data every 5 minutes
  ** ==========================================================
  */
  refreshData() {
    this.dataRefresher = setInterval(async () => {
      this.showSpinner = false;
      await this.getUserTimesheet();
    }, 300000);
  }

  ngOnDestroy() {
    if (this.dataRefresher) {
      clearInterval(this.dataRefresher);
    }
  }

  viewProject(project, projectId, typeOfProject, route, projectName) {
    // if (this.checkProjectMembers(project)){
    this.projectId = projectId
    this.projectMetrics = false;
    this.workLog = true;
    this.teamStatus = false;
    this.projectDashboard = false;
    this.timesheet = false;

    this.projectName = projectName;
    // this.router.navigate(['project-detail', { id: projectId, index: 3, projectType: typeOfProject, route: route }]);
    // }
  }

  viewProjectDashboard(project, projectId) {
    // if (this.checkProjectMembers(project)){
    this.projectId = projectId
    this.projectMetrics = false;
    this.workLog = false;
    this.teamStatus = false;
    this.timesheet = false;
    this.projectDashboard = true;
    // this.router.navigate(['projectdashboard', { id: projectId }]);
    // }
  }

  viewTimesheet(id) {
    this.projectMetrics = false;
    this.workLog = false;
    this.teamStatus = false;
    this.projectDashboard = false;
    this.timesheet = true;
    this.userId = id;
    // this.router.navigate(['timesheet-view', { id: id, event: 'project-metrics' }]);
    if (this.profileId != id) {
      this._socket.sendTimesheetNotification(id, 'Timesheet');
    }
  }

  updateProjectId(searchProjectId) {
    this.projectId = searchProjectId;
  }

  secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);

    var hDisplay = (h <= 9 ? '0' : '') + h;
    var mDisplay = (m <= 9 ? '0' : '') + m;
    return hDisplay + ':' + mDisplay;
  }

  /*
  ** ==========================================================
  ** Getting Today's Date
  ** ==========================================================
  */

  getToday(): string {
    return new Date().toISOString().split('T')[0];
  }

  async getAssignedResources(projectId): Promise<void> {
    let projectMember = this.parseService.instance.Object.extend('ProjectMembers');
    let query = new this.parseService.instance.Query(projectMember);
    query.descending('objectId');
    query.include('project');
    query.include('user');
    query.include('user.profile');
    query.include('user.profile.department');
    query.limit(10000);
    query.equalTo('project', { __type: 'Pointer', className: 'Project', objectId: projectId });
    query.equalTo('status', 'Assigned');
    query.equalTo('tenantId', this.tenantId);
    let results = await query.find();
    this.projectMembersIds = [];
    results.forEach(element => {
      this.projectMembersIds.push(element.get('user').id);
    });
  }

  teamstatusChangeDate() {
    this.getWorkHours(this.selectedProjectId, this.projectName);
  }

  async getWorkHours(projectId, projectName?) {
    // if (this.checkProjectMembers(project)){
    this.projectName = projectName;

    this.projectMetrics = false;
    this.workLog = false;
    this.teamStatus = true;
    this.projectDashboard = false;

    this.selectedProjectId = projectId;
    await this.getAssignedResources(projectId);
    this.worklogDetail = [];
    let startend = this.startenddates(this.selectbydate ? this.selectbydate : new Date());
    let timeSheet = this.parseService.instance.Object.extend('UserTimeSheet');
    let query = new this.parseService.instance.Query(timeSheet);
    query.include('user');
    query.include('user.profile');
    query.include('user.profile.department');
    query.greaterThan('createdAt', startend[0]);
    query.lessThan('createdAt', startend[1]);
    query.containedIn('user', this.projectMembersIds);
    // query.equalTo('tenantId', this.tenantId);
    query.limit(1000000);
    await query.find().then(results => {
      let worklogDetails = [];
      this.projectMembersIds.forEach(id => {
        let timeSheets = results.filter(x => x.get('user').id == id);
        let workHours = 0;
        let userName = '';
        if (timeSheets.length > 0) {
          timeSheets.forEach(tSheet => {
            let userProfile = tSheet.get('user').get('profile');
            userName = userProfile.get('firstName') + ' ' + userProfile.get('lastName');
            let totalAttendance = tSheet.get('totalAttendance');
            let workDatas = totalAttendance.project.filter(a => a.id == projectId);
            workDatas.forEach(workData => {
              workHours += workData.actualHours;
            });
          });
          if (workHours > 0) {
            worklogDetails.push({ position: 0, name: userName, id: id, workHours: workHours });
          }
        }
      });
      this.detailsToWorklogGraph(worklogDetails);
      this.worklogDetail = worklogDetails.sort(function (a, b) { return b.workHours - a.workHours });
      let totalHrs = 0;
      this.workDetail.forEach((element, index) => {
        element.position = index + 1;
        totalHrs += element.workHours;
        element.workHours = this.secondsToHms(Math.ceil(element.workHours / 1000));
      });
      this.totalWorkHours = this.secondsToHms(Math.ceil(totalHrs / 1000));
    });
    // }
  }
  // checkProjectMembers(project, Message?): boolean {
  //  const isProjectMember = project.projectMembers.length = 0 ?  true : false;
  //  if (!isProjectMember) {
  //   this.toastr.warning('No Project Members');
  //  }
  //  return isProjectMember;
  // }

  detailsToWorklogGraph(worklogDetails) {
    let names = [];
    let workHrs = [];
    this.barChartData = [];
    this.barChartLabels = [];
    worklogDetails.forEach(element => {
      names.push(element.name);
      workHrs.push((Math.ceil(element.workHours / 1000) / 3600).toFixed(1));
    });
    this.barChartLabels = names;
    this.barChartData.push({
      label: 'Work Hours',
      data: workHrs,
      backgroundColor: this.barChartColors,
    });
  }

  startenddates(day) {
    let startdate = this.daybefore(new Date(day));
    startdate.setHours(23, 59, 59, 999);
    let enddate = this.dayafter(day);
    enddate.setHours(0, 0, 0, 0);
    return [startdate, enddate];
  }

  dayafter(d) {
    let day = new Date(d);
    return new Date(day.setDate(day.getDate() + 1));
  }

  daybefore(d) {
    let day = new Date(d);
    return new Date(day.setDate(day.getDate() - 1));
  }

  back() {
    this.projectMetrics = true;
    this.workLog = false;
    this.teamStatus = false;
    this.projectDashboard = false;
    this.timesheet = false;
    this.getMetricsBasedOnProjectStatus('');
  }


}
